import React, { Component } from 'react';
import PropTypes from 'prop-types';
import autoBind from 'react-autobind';

import TextField from 'ui/common/form/fields/text-field';
import { RadioButton, RadioGroup } from 'ui/common/rebranding/components/RadioForm';

import classnames from 'classnames';

export class RadioAndTextField extends Component {
  static propTypes = {
    textFieldLabel: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      })
    ).isRequired,
  };

  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      showTextField: false,
    };
  }

  handleChange(valueFromRadioButton) {
    const { input } = this.props;
    const { onChange } = input; //from redux-form

    if (valueFromRadioButton !== 'others') {
      this.setState({
        showTextField: false,
      });

      // passing value from RadioButton to reduxForm form
      onChange(valueFromRadioButton);
    } else {
      this.setState({
        showTextField: true,
      });
      /* 
        we dont have to pass value to refux-form onChange as
        <TextField/> component already handle the value
      */
    }
  }

  render() {
    const { options, textFieldLabel } = this.props;

    return (
      <div>
        <RadioGroup onChange={this.handleChange}>
          {options.map((option, index) => {
            return (
              <RadioButton key={index} value={option.value}>
                {option.name}
              </RadioButton>
            );
          })}
        </RadioGroup>
        {this.state.showTextField && (
          <TextField
            smallLabel
            label={textFieldLabel}
            wrapperClass={classnames('pt-3')}
            {...this.props}
          />
        )}
      </div>
    );
  }
}

export default RadioAndTextField;



// WEBPACK FOOTER //
// ./src/ui/common/form/fields/radio-and-text-field.js